import React from "react";

function TargetTypeButton({ onClick, name, disabled, className = "" }) {

    const isOutline = className.includes("outline");
    const baseClass = isOutline ? "oct_btn-outline-v2" : "oct_btn-export-v2";

    return (
        <button
            type="button"
            className={`${baseClass} mb-2 mt-2 ${className} ${disabled ? 'disabled' : ''}`}
            onClick={disabled ? null : () => onClick()}
        >
            {name || '+'}
        </button>
    )

}

export default TargetTypeButton;